import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <p className="text-center small">© 2025 CSG System Inc. Public Cloud Shared Services.</p>
            </div>
        </footer>
    );
}

export default Footer;